import { type ComponentChildren } from 'preact';
import * as stylex from '@stylexjs/stylex';
import { ArrowLeftIcon } from '@xantory/icons';
import { useT } from '@xantory/i18n';
import { styles } from './page-header.styles';
interface PageHeaderProps {
  // Widened from `string` (additive) so a record page can set its number apart
  // from its title, and give its subtitle label/value rows instead of a sentence.
  title: ComponentChildren;
  desc?: ComponentChildren;
  actions?: ComponentChildren;
  /** Sub-page pattern: renders a back arrow before the title (detail/record pages). */
  onBack?: (() => void) | undefined;
  /** Inline extras after the title — status badges etc. */
  titleExtra?: ComponentChildren;
  /** A long description gets its own full-width row under the title and the actions, instead of
   *  the ~920px column beside them — for pages whose subtitle is a paragraph (it spans the whole
   *  row on a wide screen and wraps to the width of a phone on a small one). */
  wideDesc?: boolean;
}
export function PageHeader({
  title,
  desc,
  actions,
  onBack,
  titleExtra,
  wideDesc
}: PageHeaderProps) {
  const t = useT('ui');
  return <div {...stylex.props(styles.head)}>
      <div {...stylex.props(styles.titleWrap)}>
        {onBack != null && <button type="button" aria-label={t('back')} onClick={onBack} {...stylex.props(styles.backBtn)}>
            <ArrowLeftIcon size={18} />
          </button>}
        <div>
          <div {...stylex.props(styles.titleRow)}>
            <h1 {...stylex.props(styles.title)}>{title}</h1>
            {titleExtra}
          </div>
          {desc != null && !wideDesc && <div {...stylex.props(styles.desc)}>{desc}</div>}
        </div>
      </div>
      {actions != null && <div {...stylex.props(styles.actions)}>{actions}</div>}
      {desc != null && wideDesc && <div {...stylex.props(styles.desc, styles.descWide)}>{desc}</div>}
    </div>;
}